import React, { useCallback } from 'react';

const Checkbox = ({
  id,
  value,
  contrast,
  label,
  labelDisabled,
  onChange,
  disabled,
  absolute,
  title,
}) => {
  const cssClass = `label-custom-switcher big ${contrast ? 'inverted' : ''} ${
    disabled ? 'disabled-label' : 'clickable'
  }`;

  const handleSwitch = useCallback(
    (e) => {
      if (onChange) onChange(e.target.checked);
    },
    [onChange],
  );

  const handleContainerClick = useCallback(() => {
    if (onChange) onChange(!value);
  }, [onChange, value]);

  return (
    <div title={title}>
      <input id={id} type="checkbox" checked={value} onChange={handleSwitch} disabled={disabled} />{' '}
      <label
        className="custom-switcher"
        htmlFor={id}
        style={absolute && { position: 'absolute', top: '0.5rem' }}
      >
        T
      </label>
      <span className={cssClass} onClick={disabled ? null : handleContainerClick}>
        {value ? label : labelDisabled || label}
      </span>
    </div>
  );
};

export default Checkbox;
